"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ListingBookmarks_1 = require("./ListingBookmarks");
var ListingBookmarkListStore_1 = require("../model/ListingBookmarkListStore");
var ListingActions_1 = require("../ListingActions");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var AppLink_1 = require("@twii/core-ui/lib/component/AppLink");
var HostAppView_1 = require("@twii/core-ui-fabric/lib/component/HostAppView");
var UserAdminContext_1 = require("../../user/UserAdminContext");
var ListingNavHelper_1 = require("./ListingNavHelper");
var ListingBookmarksApp = /** @class */ (function (_super) {
    __extends(ListingBookmarksApp, _super);
    function ListingBookmarksApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onSelectListing = function (listing) {
            ListingActions_1.launch(_this.host, listing);
        };
        _this._onOpenStore = function () {
            ListingNavHelper_1.pushAndLoad(_this.host, { path: "/ozone/store" });
        };
        _this._onOpenAllListings = function () {
            ListingNavHelper_1.pushAndLoad(_this.host, { path: "/ozone/listings" });
        };
        _this._onRenderNoBookmarks = function () {
            return (React.createElement("div", { style: { padding: 8 } },
                React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.info },
                    "You haven't bookmarked anything. ",
                    React.createElement(AppLink_1.AppLink, { host: _this.host, request: { path: "/ozone/store" }, onClick: _this._onOpenStore }, "Take a look in the Store"),
                    ".")));
        };
        return _this;
    }
    Object.defineProperty(ListingBookmarksApp.prototype, "host", {
        get: function () {
            return this.props.match.host;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingBookmarksApp.prototype, "userProfile", {
        get: function () {
            return this.props.match.userProfile;
        },
        enumerable: true,
        configurable: true
    });
    ListingBookmarksApp.prototype.componentWillMount = function () {
        this.host.setTitle("Bookmarks");
    };
    ListingBookmarksApp.prototype.render = function () {
        var items = [
            {
                key: "store",
                name: "Store",
                iconProps: {
                    iconName: "Shop"
                },
                onClick: this._onOpenStore
            }
        ];
        if (UserAdminContext_1.UserAdminContext.value(this.userProfile)) {
            items.push({
                key: "listings",
                name: "All Listings",
                iconProps: {
                    iconName: "ViewList"
                },
                onClick: this._onOpenAllListings
            });
        }
        return (React.createElement(HostAppView_1.HostAppView, { host: this.host, commandBarProps: { items: items } },
            React.createElement(ListingBookmarks_1.ListingBookmarksContainer, { bookmarkList: ListingBookmarkListStore_1.ListingBookmarkListStore, onSelectListing: this._onSelectListing, onRenderNoBookmarks: this._onRenderNoBookmarks })));
    };
    return ListingBookmarksApp;
}(React.Component));
exports.ListingBookmarksApp = ListingBookmarksApp;
exports.default = ListingBookmarksApp;
